import React, { useState, useEffect } from "react";
import "../../styles/authentication/login.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, onAuthStateChanged, signInWithPopup } from "firebase/auth";
import { firebaseAuth, firebaseFirestore, googleProvider } from "../firebase/firebase_configuration";
import { collection, doc, getDocs, serverTimestamp, setDoc } from "firebase/firestore";

import loginImage from "../../images/authentication/login_image.png";
import emailIcon from "../../images/authentication/email_icon.png";
import passwordIcon from "../../images/authentication/password_icon.png";
import googleIcon from "../../images/authentication/google_icon.png";

const Login = () => {
    const goTo = useNavigate();
    const [getEmail, setEmail] = useState("");
    const [getPassword, setPassword] = useState("");

    useEffect (() =>{
        const isLoggedIn = onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                goTo("/main_back/home", {replace: true});
            }
        });

        return () => isLoggedIn();
    }, [goTo]);

    const onGoogleLogIn = async () => {
        try {
            const result = await signInWithPopup(firebaseAuth, googleProvider);
            const user = result.user;
            const userID = user.uid;
            const usersRef = collection(firebaseFirestore, 'User Details');
            const querySnapshot = await getDocs(usersRef);
            let userExists = false;

            querySnapshot.forEach((doc) => {
                if (doc.id === userID) {
                    userExists = true;
                }
            });

            if (userExists) {
                setTimeout(() => {
                    goTo("/main_back/home");
                }, 1000);
            } else {
                const username = `${user.displayName == null ? "" : user.displayName.split(" ")[0]}`;
                const email = `${user.email == null ? "" : user.email}`;
                const image = `${user.photoURL == null ? "" : user.photoURL}`;

                const userRef = doc(firebaseFirestore, 'User Details', userID);
                await setDoc(userRef, {
                    "username": username,
                    "email": email,
                    "image": image,
                    "dateCreated": serverTimestamp()
                });

                setTimeout(() => {
                    goTo("/main_back/home");
                }, 1000);
            }
        } catch (error) {
            alert(error.message);
            console.error('Error during Google login.');
        };
    };

    const onSignup = () => {
        goTo("/signup");
    };

    const onChangeEmail = (email) => {
        setEmail(email.target.value);
    };

    const onChangePassword = (password) => {
        setPassword(password.target.value);
    };

    const onLogin = async (form) => {
        form.preventDefault();

        try {
            await signInWithEmailAndPassword(firebaseAuth, getEmail, getPassword);
            setTimeout(() => {
                goTo("/main_back/home");
            }, 1000);
        } catch (error) {
            alert("Invalid email or password. Please try again.");
        }
    };

    return (
        <div className="login_screen">
            <div className="login_left">
                <img src={loginImage} alt="Login wallpaper" className="loginImage" />
            </div>
            
            <form method="post" onSubmit={onLogin} className="login_right">
                <p className="login_header">Continue Using Movinity</p>

                <p className="login_input_label" >Email Address</p>
                <div className="login_input_container">
                    <img alt="email" src={emailIcon} className="login_input_icon"/>
                    <input className="login_input_field" id="email" placeholder="Enter a valid email" type="email" value={getEmail} onChange={onChangeEmail} required />
                </div>

                <p className="login_input_label" >Password</p>
                <div className="login_input_container">
                    <img alt="password" src={passwordIcon} className="login_input_icon_2"/>
                    <input className="login_input_field" id="password" placeholder="Enter a password" type="password" minLength={8} value={getPassword} onChange={onChangePassword} required />
                </div>

                <input type="submit" className="button" value={'Login'} />

                <div className="already_container">
                    <p className="already_text">Dont't have an accout?</p>
                    <p className="already_link" onClick={() => onSignup()}>Signup</p>
                </div>

                <div className="or_container">
                    <div className="or_line"></div>
                    OR
                    <div className="or_line"></div>
                </div>

                <div className="google_button" onClick={onGoogleLogIn}>
                    <img alt="google" src={googleIcon} />
                    Login with Google
                </div>

            </form>
        </div>
    );
};

export default Login;